module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point01_01_travel-9f45a80d4dfbfa5948cd36270b839153.jpg";